import React, { useEffect } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  Checkbox,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { IN_ROOM_DINING_COMBO_EDIT } from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import { selectedHotelCurrencySelector } from '../../../../property/propertySlice';
import { useSelector } from 'react-redux';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { PARTIAL_CHECKBOX_GREEN, updateSelectedModule } from '../../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';

const InRoomDiningComboListTable = (props) => {
  const {
    combosList,
    setCombosList,
    dragDisabled,
    page,
    rowsPerPage,
    handleCellMenuClick,
    selectedValue,
    handleClose,
    onClickRowViewDetails,
    onViewDetails,
    handleChangePage,
    handleChangeRowsPerPage,
    onOpenDrawer,
    onActiveDeActiveCombo,
    onDeleteCombo,
    permissions,
    setVisible,
    searchText,
    handleSelectAll,
    isAllSelected,
    setIsAllSelected,
    handleCheckboxChange,
    setActionMenuList,
    selectedComboLength,
    inRoomDiningCombos,
  } = props;

  const currency = useSelector(selectedHotelCurrencySelector);

  useEffect(() => {
    updateSelectedModule(combosList, setActionMenuList, setIsAllSelected);
  }, [combosList]);

  return (
    <TableContainer>
      <Table className='list-table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
              <BulkActionCheckBox
                onChange={handleSelectAll}
                checked={isAllSelected || false}
                selectedLength={selectedComboLength}
                totalLength={inRoomDiningCombos?.length}
                inputProps={{
                  'aria-label': 'select all Combo',
                }}
                className={PARTIAL_CHECKBOX_GREEN}
              />
            </TableCell>
            <TableCell className='w-30'>Name</TableCell>
            <TableCell className='w-20' align='right'>
              No of Items
            </TableCell>
            <TableCell className='w-20' align='right'>
              Combo price
            </TableCell>
            <TableCell className='w-30' align='center'>
              Status
            </TableCell>
            <TableCell align='right'></TableCell>
          </TableRow>
        </TableHead>

        <DragDropContext
          onDragEnd={(event) =>
            handleOnDragEnd(event, setVisible, combosList, setCombosList, false, page, rowsPerPage)
          }
          isDropDisabled={dragDisabled}
        >
          <Droppable droppableId='services' isDropDisabled={dragDisabled}>
            {(provided) => (
              <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                {(rowsPerPage > 0
                  ? combosList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : combosList
                ).map((comboKey, key) => (
                  <Draggable
                    key={comboKey.id}
                    draggableId={comboKey.id}
                    index={key}
                    isDragDisabled={dragDisabled}
                  >
                    {(provided) => (
                      <TableRow
                        key={key}
                        className='border-white pointer'
                        onClick={(e) => {
                          onClickRowViewDetails(comboKey, e);
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <TableCell className='w-12'>
                          {!dragDisabled && (
                            <span style={{ marginRight: 1.5 }}>
                              <DragIndicator className='res-menu-accordion-drag' />
                            </span>
                          )}
                          <Checkbox
                            onChange={(event) => handleCheckboxChange(comboKey?.id)}
                            checked={comboKey?.isChecked || false}
                            inputProps={{
                              'aria-label': `select combo ${comboKey?.id}`,
                            }}
                          />
                        </TableCell>
                        <TableCell className='w-30'>{comboKey?.name}</TableCell>
                        <TableCell className='w-20' align='right'>
                          {comboKey?.items?.length || 0}
                        </TableCell>
                        <TableCell className='w-20' align='right'>
                          {currency + ' '} {comboKey?.price}
                        </TableCell>
                        <TableCell className='w-30' align='center'>
                          <CustomChip
                            label={comboKey.status ? 'Active' : 'Inactive'}
                            color={comboKey.status ? 'primary' : 'default'}
                          />
                        </TableCell>
                        <TableCell align='right' className='kebab-menu'>
                          {permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] ===
                            RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                            <Button
                              aria-controls='simple-menu'
                              aria-haspopup='true'
                              onClick={(e) => {
                                handleCellMenuClick(e, comboKey);
                              }}
                              className='showpopupInner'
                            >
                              <MoreHoriz className='showpopupInner' />
                            </Button>
                          )}
                          <Menu
                            id={key}
                            anchorEl={selectedValue?.anchorEl}
                            disableRestoreFocus
                            MenuListProps={{ autoFocusItem: false }}
                            keepMounted
                            open={
                              Boolean(selectedValue.anchorEl) && selectedValue.id === comboKey.id
                            }
                            onClose={handleClose}
                            className='shadow'
                          >
                            <MenuItem
                              className='pe-4'
                              onClick={(e) =>
                                onActiveDeActiveCombo(
                                  e,
                                  selectedValue?.combo?.status ? 'deactivate' : 'active',
                                )
                              }
                            >
                              {selectedValue?.combo?.status ? (
                                <>
                                  <RemoveCircle className='me-2 action-menu-icon' />
                                  Deactivate
                                </>
                              ) : (
                                <>
                                  <AddCircle className='me-2 action-menu-icon' />
                                  Activate
                                </>
                              )}
                            </MenuItem>
                            <MenuItem
                              className='pe-4'
                              onClick={(e) => onOpenDrawer(e, IN_ROOM_DINING_COMBO_EDIT)}
                            >
                              <CreateIcon className='me-2 action-menu-icon' />
                              Edit
                            </MenuItem>
                            <MenuItem className='pe-4' onClick={(e) => onViewDetails(comboKey, e)}>
                              <VisibilityIcon className='me-2 action-menu-icon' />
                              View
                            </MenuItem>
                            <MenuItem className='pe-4' onClick={(e) => onDeleteCombo(e)}>
                              <DeleteForeverIcon className='me-2 action-menu-icon' />
                              Delete
                            </MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </DragDropContext>
        <TableFooter>
          <TableRow className='paginator'>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              count={combosList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default InRoomDiningComboListTable;
